import { createAction } from '@reduxjs/toolkit'

import { curryActionForPath } from 'helpers/curry'
import {
    ActionForPathPayload,
    FilterSettings,
    FiltersState,
    FilterValue,
    UiFilterSetConfiguration,
} from 'types'

interface FilterUpdatePayload {
    key: string
    value?: FilterValue | number
    automaticallyMade?: boolean
    args?: unknown[]
}

// Filter Settings
export const fetchFilterSettingsSuccess = createAction<
    ActionForPathPayload<FilterSettings>
>('FETCH_FILTER_SETTINGS_SUCCESS')
export const updateFilterSettings = createAction<
    ActionForPathPayload<Partial<FilterSettings>>
>('UPDATE_FILTER_SETTINGS')

export const makeUpdateFilterSettings = curryActionForPath(updateFilterSettings)

// Filters
export const fetchFiltersSuccess = createAction<
    ActionForPathPayload<{ filters: FiltersState }>
>('FETCH_FILTERS_SUCCESS')
export const updateLocalFilter = createAction<
    ActionForPathPayload<FilterUpdatePayload>
>('UPDATE_LOCAL_FILTER')
export const updateFilter =
    createAction<ActionForPathPayload<FilterUpdatePayload>>('UPDATE_FILTER')
export const resetFilters =
    createAction<ActionForPathPayload<unknown>>('RESET_FILTERS')
export const resetLocalFilters = createAction<ActionForPathPayload<unknown>>(
    'RESET_LOCAL_FILTERS'
)
export const setFilters =
    createAction<ActionForPathPayload<UiFilterSetConfiguration>>('SET_FILTERS')
export const setSavedFilterSet = createAction<
    ActionForPathPayload<UiFilterSetConfiguration | undefined>
>('SET_SAVED_FILTER_SET')

export const makeUpdateLocalFilter = curryActionForPath(updateLocalFilter)
export const makeUpdateFilter = curryActionForPath(updateFilter)
export const makeResetFilters = curryActionForPath(resetFilters)
export const makeResetLocalFilters = curryActionForPath(resetLocalFilters)
export const makeSetFilters = curryActionForPath(setFilters)
export const makeSetSavedFilterSet = curryActionForPath(setSavedFilterSet)
